import React, { useState } from "react";
import { Upload, Button, Typography, List, message, Card, Select } from "antd";
import {
  InboxOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import "./uploads.css";
import { Table } from "antd";
import { RecentAutoData } from "../../../data";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../../utils/axiosInterceptor";
const { Dragger } = Upload;
const { Text, Link } = Typography;

export const list = [
  {
    id: 1,
    name: "COGS",
  },
  {
    id: 2,
    name: "Rebate",
  },
  {
    id: 3,
    name: "LocID",
  },
  {
    id: 4,
    name: "Master",
  },
];

const Uploads = ({
  loading,
  // uploadedfiles,
  // setFilterFile,
  // filterFile,
  getAllUploadedFiles,
  // getUploadedFiles,
  getRebateData,
  getCogsData,
  allUploadFiles,
}) => {
  const [fileList, setFileList] = useState([]);
  const [fileType, setFileType] = useState([]);
  const [dropdownAvail, setDropDownAvail] = useState(false);
  const userDetails = useSelector((state) => state.userAuth.decodedToken.user);
  const [fileType2, setFileType2] = useState("COGS");
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(10);

  const columns = [
    {
      title: "File Name",
      dataIndex: "FileName",
      key: "FileName",
      sorter: true,
    },
    {
      title: "Uploaded By",
      dataIndex: "UploadedBy",
      key: "UploadedBy",
      // sorter: true,
    },
    {
      title: "Upload Time",
      dataIndex: "UploadedAt",
      key: "UploadedAt",
      render: (text) => {
        const date = new Date(text);
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month (1–12)
        const day = String(date.getDate()).padStart(2, "0"); // Day (1–31)
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      },

      // sorter: true,
    },
    {
      title: "File Type",
      dataIndex: "FileType",
      key: "FileType",
      // sorter:true
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      // sorter: true,
    },
  ];
  const props = {
    name: "file",
    multiple: true,
    action: undefined,
    beforeUpload: (file) => {
      const allowedTypes = [
        "text/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (!allowedTypes.includes(file.type)) {
        message.error("Only .csv and .xlsx files are allowed!");
        return Upload.LIST_IGNORE; 
      }
      if (!fileType || fileType?.length == 0) {
        message.error("Please Select a File Type ");
        return Upload.LIST_IGNORE;
      }
      const fileName = file.name;
      if (fileType === "COGS") {
      const cogsPattern = /^AAPA COGs Audit_\d{2}\.\d{2}\.\d{4}$/;
      if (!cogsPattern.test(fileName.replace(/\.(csv|xlsx)$/, ""))) {
        message.error(
          "Invalid file name. Expected format: AAPA COGs Audit_MM.DD.YYYY"
        );
        return Upload.LIST_IGNORE;
      }
    }

    if (fileType === "Rebate") {
      const rebatePattern = /^\d{6} AAPA GX BX Report_Final$/;
      if (!rebatePattern.test(fileName.replace(/\.(csv|xlsx)$/, ""))) {
        message.error(
          "Invalid file name. Expected format: YYYYMM AAPA GX BX Report_Final"
        );
        return Upload.LIST_IGNORE;
      }
    }

    if (fileType === "LocID") {
      const locPattern = /^AAPA_LOC_ID_Report_\d{4}_\d{2}_\d{2}$/;
      if (!locPattern.test(fileName.replace(/\.(csv|xlsx)$/, ""))) {
        message.error(
          "Invalid file name. Expected format: AAPA_LOC_ID_Report_YYYY_MM_DD"
        );
        return Upload.LIST_IGNORE;
      }
    }
    if (fileType === "Master") {
    const pattern = /^AAPA Membership Roster_\d{2}_\d{2}_\d{4}$/;
    if (!pattern.test(fileName.replace(/\.(csv|xlsx)$/, ""))) {
      message.error(
        "Invalid file name. Expected format: AAPA Membership Roster_MM_DD_YYYY"
      );
      return Upload.LIST_IGNORE;
    }
    }
      setFileList((prev) => [...prev, file]);
      return false;
    },
    //   setFileList((prev) => [...prev, file]);
    //   return false; // stop default upload
    // },

    onRemove: (file) => {
      setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
    },

    showUploadList: {
      showRemoveIcon: true,
      showPreviewIcon: false,
      showDownloadIcon: false,
    },
    onPreview: (file) => {
      const fileURL = URL.createObjectURL(file.originFileObj || file);
      window.open(fileURL, "_blank");
    },
  };

  const uploadFiles = async (file) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file.originFileObj ?? file);
      formData.append("fileType", fileType);
      formData.append("uploadedBy", userDetails?.first_name);
      const response = await axiosInstance.post(
        `/automationRouter/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFileType([]);
      setDropDownAvail(false);
      setFileList([]);
      // getUploadedFiles()
      getRebateData();
      getCogsData();
      getAllUploadedFiles();
    } catch (error) {
      console.log(error, "erroror");
      message.error("Not Uploaded");
    } finally {
      console.log("");
      setIsLoading(false);
    }
  };

  const updateFileType = (e) => {
    setFileType(e);
    setDropDownAvail(true);
    // setFileList()
  };
  const updateFileType2 = (e) => {
    setFileType2(e);
    // setFilterFile(e);
    // setFileList()
  };

  return (
    <div>
      <Card
        title={
          <div className="flex justify-between items-center">
            <span className="font-semibold text-[16px] leading-[100%] tracking-[0%] text-justify text-[#000833]">
              File Exceptions
            </span>
            <div className="flex items-center gap-4">
              <div className="-mr-1">
                <InfoCircleOutlined className="mr-2" />
                <MoreOutlined />
              </div>
            </div>
          </div>
        }
      >
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 w-full md:w-auto">
          <Select
            // mode="multiple"
            value={fileType}
            onChange={updateFileType}
            className="w-full md:w-[300px] "
            style={{
              // width: "400px",
              border: "1px solid #d9d9d9",
              "border-radius": "6px",
            }}
            placeholder="Select FileType"
            options={list?.map((i) => ({
              label: i.name || i.name,
              value: i.name || i.name,
              key: i.id,
            }))}
            // showSearch
            maxTagCount={3}
          />
        </div>
        {/* {dropdownAvail && ( */}
        <div className="flex items-center justify-center min-h-[40vh]">
          <div className="w-full max-w-lg bg-white rounded-lg mx-auto p-4 sm:p-6">
            <Dragger
              {...props}
              fileList={fileList}
              className="border-dashed border-[#d9d9d9] rounded-lg bg-[#f9fbff] hover:bg-[#f5f9ff] transition-all duration-200"
              itemRender={(originNode, file) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "4px 8px",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  {/* 👇 clickable file name with pointer */}
                  <div>
                    <span
                      onClick={() => {
                        const fileURL = URL.createObjectURL(
                          file.originFileObj || file
                        );
                        window.open(fileURL, "_blank");
                      }}
                      style={{
                        color: "#1677ff",
                        cursor: "pointer",
                        textDecoration: "underline",
                        wordBreak: "break-all",
                      }}
                    >
                      {file.name}
                    </span>
                    {/* <span
                onClick={() => props.onRemove(file)}
                style={{
                  color: "red",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                ✕
              </span> */}
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      danger
                      onClick={() => props.onRemove(file)}
                    />
                  </div>
                  <div>
                    <Button
                      type="primary"
                      loading={isLoading}
                      className="h-30"
                      onClick={() => uploadFiles(file)}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              )}
            >
              <div className="flex flex-col items-center py-10">
                <InboxOutlined style={{ fontSize: "48px", color: "#1890ff" }} />
                <p className="text-gray-600 text-base mt-3">
                  Drop your file here, or{" "}
                  <span className="text-[#1890ff] cursor-pointer hover:underline">
                    browse
                  </span>
                </p>
                <p className="text-gray-400 text-sm mt-1">
                  Supports: CSV and XLSX
                </p>
               <div className="mt-4 w-full px-2">
              <div className="bg-gray-50 border border-gray-200 rounded-md p-3 w-full max-w-full">
                        
                <p className="text-xs font-semibold text-red-500 mb-2 tracking-wide uppercase text-center">
                  Note 
                </p>
                        
                <div className="text-xs sm:text-sm text-gray-700 space-y-2 break-all">
                   <p className="text-start text-[13px]">
                    <span className="font-medium text-gray-900">File Naming Formats – </span>
                  </p>
                  <p className="text-start text-[13px]">
                    <span className="font-medium text-gray-900">COGS – </span>
                    AAPA COGs Audit_09.25.2025.xlsx
                  </p>
                        
                  <p className="text-start text-[13px]">
                    <span className="font-medium text-gray-900">Rebate – </span>
                    202601 AAPA GX BX Report_Final.xlsx
                  </p>
                        
                  <p className="text-start text-[13px]">
                    <span className="font-medium text-gray-900">LOC ID – </span>
                    AAPA_LOC_ID_Report_2025_12_17.xlsx
                  </p>
                  <p className="text-start text-[13px]">
                    <span className="font-medium text-gray-900">Master – </span>
                    AAPA Membership Roster_04_22_2026.xlsx
                  </p>
                        
                </div>
              </div>
            </div>
              </div>
            </Dragger>
          </div>
        </div>
        {/* )} */}

        <div className="flex mt-20 sm:flex-row sm:flex-wrap gap-4 justify-end w-full md:w-auto">
          <Select
            // mode="multiple"
            value={fileType2}
            onChange={updateFileType2}
            className="w-full md:w-[200px] "
            style={{
              // width: "400px",
              border: "1px solid #d9d9d9",
              "border-radius": "6px",
            }}
            placeholder="Select Filter"
            options={list?.map((i) => ({
              label: i.name || i.name,
              value: i.name || i.name,
              key: i.id,
            }))}
            // showSearch
            maxTagCount={3}
          />
        </div>
        <div className="mt-10">
          <Table
            columns={columns}
            dataSource={allUploadFiles.filter(
              (item) => item.FileType === fileType2
            )}
            //   pagination={pagination}
            //   onChange={handleTableChange}
            loading={loading}
            scroll={{ x: "max-content" }}
            rowKey="id"
            size="middle"
            className="custom-table user-tbl"
            pagination={{
              pageSize: pagination,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} accounts`,
              onShowSizeChange: (current, size) => {
                setPagination(size);
              },
            }}
          />
        </div>
      </Card>
    </div>
  );
};

export default Uploads;